const QRAccess = () => import(/* webpackChunkName: "qraccess" */ "../../views/qrAcess/QRAcess.vue")
const Trips = () => import(/* webpackChunkName: "trips" */ "../../views/qrAcess/Trips/Trips.vue")
const TripDetails = () => import(/* webpackChunkName: "trips details" */ "../../views/qrAcess/Trips/TripDetails.vue")
const TripPassengers = () => import(/* webpackChunkName: "trip passengers" */ "../../views/qrAcess/Trips/TripPassengers.vue")
const TripPassengerDetail = () => import(/* webpackChunkName: "trip passenger detail" */ "../../views/qrAcess/Trips/TripPassengerDetail.vue")
const TripDriverDetail = () => import(/* webpackChunkName: "trip driver detail" */ "../../views/qrAcess/Trips/TripDriverDetail.vue")
const Drivers = () => import(/* webpackChunkName: "drivers" */ "../../views/qrAcess/Drivers/Drivers.vue")
const CRUDDriver = () => import(/* webpackChunkName: "new driver" */ "../../views/qrAcess/Drivers/CRUDDriver.vue")
const BusRoutes = () => import(/* webpackChunkName: "trips details" */ "../../views/qrAcess/BusRoutes/BusRoutes.vue")
const Reports = () => import(/* webpackChunkName: "reports" */"../../views/qrAcess/Reports/Reports.vue")

const qrAcessRoutes = [{
  path: "qraccess",
  name: "QR Access",
  redirect: {
    name: "Trips"
  },
  component: QRAccess,
  children: [{
      path: "trips",
      name: "Trips",
      component: Trips,
      props: true
    }, {
      path: "trips/trip/:id",
      name: "Trip Details",
      component: TripDetails,
      props: true
    }, {
      path: "trips/trip/:id/passengers",
      name: "Trip Passengers",
      component: TripPassengers,
      props: true
    }, {
      path: "trips/trip/:id/passengers/:id",
      name: "Trip Passenger Detail",
      component: TripPassengerDetail,
      props: true
    }, {
      path: "trips/trip/:id/driver/:id",
      name: "Trip Driver Detail",
      component: TripDriverDetail,
      props: true
    }, {
      path: "drivers",
      name: "Drivers",
      component: Drivers,
    }, {
      path: "drivers/new",
      name: "New Driver",
      component: CRUDDriver,
      props: true
    }, {
      path: "drivers/details/:id",
      name: "Driver Details",
      component: CRUDDriver,
      props: true
    }, {
      path: "drivers/edit/:id",
      name: "Edit Driver",
      component: CRUDDriver,
      props: true
    }, {
      path: "busRoutes",
      name: "Bus Routes",
      component: BusRoutes
    }, {
      path: "reports",
      name: "Reports",
      component: Reports
    }
  ]
}];

export default qrAcessRoutes;
